__turbopack_context__.v({
  "popup": "popover-module-scss-module__l0Etka__popup",
  "positioner": "popover-module-scss-module__l0Etka__positioner",
});
